import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoginState } from './login.models';

export const selectLoginState = createFeatureSelector<LoginState>('login');

export const isLoggedIn = createSelector(
  selectLoginState,
  (state: LoginState) => state?.authenticated?.[state.currentEmail],
);

export const getUser = createSelector(selectLoginState, (state: LoginState) => state.currentEmail);

export const getError = createSelector(selectLoginState, (state: LoginState) => state.error);

export const loginLoading = createSelector(selectLoginState, (state: LoginState) => state.loading);
